import { render, staticRenderFns } from "./CommitToCharity.vue?vue&type=template&id=6cabb988&scoped=true"
var script = {}
import style0 from "./CommitToCharity.vue?vue&type=style&index=0&id=6cabb988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cabb988",
  null
  
)

export default component.exports